<script>
export default {
  props: {
    item: {
      type: Object
    },
    content: {
      type: Object
    },
    canDelete: {
      type: Boolean
    },
    order: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      selectedAttachments: [],
      attachmentsDeleting: false
    }
  },
  methods: {
    async deleteAttachments() {
      this.attachmentsDeleting = true
      await this.$uploadService
        .deleteAttachments({
          documentId: this.item.documentId,
          attachmentIds: this.selectedAttachments,
          orderId: this.order.id
        })
        .then(() => {
          this.$emit('deleted')
        })
        .catch(() => {})
        .finally(() => {
          this.attachmentsDeleting = false
        })
    }
  }
}
</script>
<template>
  <v-expansion-panel
    v-if="item.attachments != undefined && item.attachments.length > 0"
    id="upload_validation_details_attachments">
    <v-expansion-panel-header>
      {{ $t('component.documentValidation.documentDetailsAttachments.header') }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-list id="attachmentList" class="pt-0 pb-0">
        <div v-for="(attachment, index) in item.attachments" :key="index">
          <v-tooltip left>
            <template #activator="{ on, attrs }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-checkbox
                  v-if="order.hasOwnProperty('orderStatus') && order.orderStatus < 400 && canDelete"
                  :id="`upload_validation_attachment_checkbox_${attachment.id}`"
                  v-model="selectedAttachments"
                  :value="attachment.id"
                  :label="attachment.fileName"
                  hide-details
                  color="error"
                  class="mt-0"
                ></v-checkbox>
                <v-chip v-else label class="mb-1">
                  {{ attachment.fileName }}
                </v-chip>
              </v-list-item>
            </template>
            <span>{{ $t('component.documentValidation.documentDetailsAttachments.pages') }}:
              {{ attachment.pageCount }}</span>
          </v-tooltip>
        </div>
        <v-list-item-action v-if="typeof order === 'object' && order.hasOwnProperty('orderStatus') && order.orderStatus < 400 && canDelete" class="mb-0">
          <v-btn
            id="upload_validation_remove_attachments"
            :loading="attachmentsDeleting"
            :disabled="selectedAttachments.length <= 0"
            color="error"
            @click="deleteAttachments">
            <v-icon dark>mdi-delete-forever</v-icon>
            {{ $t('button.delete') }}
          </v-btn>
        </v-list-item-action>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
.v-list-item {
  min-height: 28px;
}
.v-list-item__content {
  padding: 0 !important;
}
</style>
